// DOM 查询与渲染的小工具集 / Tiny DOM query + render helpers shared across the SPA.
// 提供带类型的 $ / $maybe、可见性与文本切换、以及 HTML 转义。
// Provides typed $ / $maybe, visibility + text setters, and HTML escaping.

export function $<E extends HTMLElement = HTMLElement>(id: string): E {
  const el = document.getElementById(id);
  if (el === null) {
    throw new Error(`missing element #${id}`);
  }
  return el as E;
}

export function $maybe<E extends HTMLElement = HTMLElement>(id: string): E | null {
  return document.getElementById(id) as E | null;
}

export function setHidden(id: string, hidden: boolean): void {
  const el = $maybe(id);
  if (el) el.hidden = hidden;
}

export function setText(id: string, text: string): void {
  const el = $maybe(id);
  if (el) el.textContent = text;
}

export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
